module.exports = __webpack_public_path__ + "static/media/use-em-love-em.82e21452.png";